import _ from 'lodash';
import ui from './ui';
import Document from 'document';
import ComponentsBatchFunctions from './privates/utils/componentsBatchFunctions';
import {types} from 'privates/utils';
import {onReady} from 'privates/readyManager';
import wixSelectorUtils from 'privates/wixSelectorUtils';
import HiddenCollapsedElement from 'ui/HiddenCollapsedElement';
import monitoring from 'privates/monitoring';

class WixSelector {
  initialize(RMI, contextId, emitter) {
    this.RMI = RMI;
    this.contextId = contextId;
    this.emitter = emitter;
  }

  scoped$W(controllerId, logName) {
    const $w = (selector) => this.$w.call(this, controllerId, logName, selector, false);
    $w.scoped = (selector) => this.$w.call(this, controllerId, logName, selector, true);

    return $w;
  }

  $w(controllerId, logName, compSelector, onlyNestedScope) {

    if (_.isFunction(compSelector)) {
      onReady(compSelector, logName);
      return;
    }

    if (!_.isString(compSelector)) {
      throw new Error("The value passed to the element selector function (usually $w), must be of type string");
    }

    if (!this.RMI) {
      throw new Error("The element selector function (usually $w) cannot be used before the page is ready");
    }

    const scopedRMI = this.RMI.getScopedRMI(controllerId);
    const wixComps = [];

    const isCompName = (compSelector) => compSelector.trim().indexOf('#') === 0;
    const isRole = (compSelector) => compSelector.trim().indexOf('@') === 0;
    const isType = (compSelector) => types.getPotentialViewerTypes(compSelector).length > 0 || compSelector === 'PageContent';
    const getType = (compSelector) => { return compSelector === 'PageContent' ? 'Page' : compSelector; };
    const isMulti = (compSelector) => compSelector.indexOf(',') > -1;
    const isDocument = (compSelector) => compSelector === 'Document';
    const selector = compSelector.trim().substr(1);

    switch (true) {
      case isDocument(compSelector):
        const cIds = scopedRMI.getCompIdsFromRole(selector, onlyNestedScope);
        return new Document(scopedRMI, cIds[0], this.contextId, this, controllerId, undefined, {compType: 'Document'}, this.emitter);
      case isType(compSelector):
        const type = getType(compSelector);
        const comps = wixSelectorUtils.getCompsForType(types, scopedRMI, type, onlyNestedScope);
        comps.forEach((comp) => {
          wixComps.push(this.getInstance(scopedRMI, comp.type, comp.id, controllerId));
        });
        return ComponentsBatchFunctions.expose(wixComps);
      case isMulti(compSelector):
        const selectors = compSelector.split(',');
        const selectedComps = [];
        selectors.forEach((comp) => {
          if (isCompName(comp)) {
            const sel = comp.trim().substr(1);
            const id = scopedRMI.getCompIdsFromRole(sel, onlyNestedScope)[0];
            const component = this.getInstance(scopedRMI, scopedRMI.getType(id), id, controllerId);
            if (!_.isArray(component)) {
              const isCompInArr = _.find(selectedComps, {id});
              if (!isCompInArr) {
                selectedComps.push({
                  id,
                  type: scopedRMI.getType(id)
                });
              }
            }
          } else if (isType(comp.trim())){
            const type = getType(comp.trim());
            const comps = wixSelectorUtils.getCompsForType(types, scopedRMI, type);
            comps.forEach((comp) => {
              const isCompInArr = _.find(selectedComps, {id: comp.id});
              if (!isCompInArr) {
                selectedComps.push(comp);
              }
            });
          }
        });
        selectedComps.forEach((comp) => {
            wixComps.push(this.getInstance(scopedRMI, comp.type, comp.id, controllerId));
        });
        return ComponentsBatchFunctions.expose(_.without(wixComps, undefined));
      case isCompName(compSelector):
        const ids = scopedRMI.getCompIdsFromRole(selector, onlyNestedScope);
        return !_.isEmpty(ids) ? this.getInstance(scopedRMI, scopedRMI.getType(ids[0]), ids[0], controllerId) : [];
      case isRole(compSelector):
        const compIds = scopedRMI.getCompIdsFromRole(selector, onlyNestedScope);
        compIds.forEach((compId) => {
          wixComps.push(this.getInstance(scopedRMI, scopedRMI.getType(compId), compId, controllerId, selector));
        });
        return ComponentsBatchFunctions.expose(wixComps);
      default:
        return [];
    }
  }

  getInstance(scopedRMI, viewerType, compId, controllerId, role) {
      const compType = wixSelectorUtils.getSdkConstructorName(types, scopedRMI, compId);
      const Clazz = ui[compType] || HiddenCollapsedElement;
      return viewerType ? new Clazz(scopedRMI, compId, this.contextId, this, controllerId, role, {compType, viewerType}, this.emitter) : [];
  }

  getScopedSelector(compId, scopedContext, scopedController) {
    const contextId = scopedContext || this.contextId;
    const controllerId = scopedController || contextId;
    const scopedRMI = this.RMI.getScopedRMIByCompId(compId);
    let $w;

    if(scopedRMI === this.RMI){
      $w = this.scoped$W(controllerId);
    } else {
      const scopedSelector = new this.constructor();
      scopedSelector.initialize(scopedRMI, contextId, this.emitter);
      $w = scopedSelector.scoped$W(controllerId);
    }

    _.assign($w, this.emitter.createScopedEmitter(controllerId));

    return $w;
  }

  getScopedSelectorForDisplayedOnlyComp(repeaterCompId, itemId, scopedContext, scopedController) {
    const contextId = scopedContext || this.contextId;
    const controllerId = scopedController || contextId;
    const scopedRMI = this.RMI.getScopedRMIForRepeaterItem(repeaterCompId, itemId);

    const scopedSelector = new this.constructor();
    scopedSelector.initialize(scopedRMI, contextId, this.emitter);
    const $w = scopedSelector.scoped$W(controllerId);
    _.assign($w, this.emitter.createScopedEmitter(controllerId));

    return $w;
  }
}

export default monitoring.monitorClass(WixSelector, function(){
  return {RMI: this.RMI, contextId: this.contextId, emitter: this.emitter};
});



// WEBPACK FOOTER //
// ./js/modules/wixSelector.es6